import type { Paginated } from "./api";

type PaginatorMeta = Paginated<unknown>["meta"];

function metaFromRecord(meta: Record<string, unknown>): PaginatorMeta {
  return {
    total: Number(meta.total ?? 0),
    per_page: Number(meta.per_page ?? 15),
    current_page: Number(meta.current_page ?? 1),
    last_page: Number(meta.last_page ?? 1),
  };
}

export function normalizePaginated<T>(body: unknown): Paginated<T> {
  if (!body || typeof body !== "object") {
    throw new Error("Invalid paginated response");
  }

  const root = body as Record<string, unknown>;

  if (root.success === true && root.data && typeof root.data === "object" && !Array.isArray(root.data)) {
    const paginator = root.data as Record<string, unknown>;
    if (Array.isArray(paginator.data)) {
      return {
        data: paginator.data as T[],
        meta: metaFromRecord(paginator),
      };
    }
  }

  if (Array.isArray(root.data)) {
    const meta =
      root.meta && typeof root.meta === "object"
        ? metaFromRecord(root.meta as Record<string, unknown>)
        : { total: root.data.length, per_page: root.data.length, current_page: 1, last_page: 1 };
    return { data: root.data as T[], meta };
  }

  throw new Error("Unrecognized paginated response shape");
}

export function unwrapItem<T>(body: unknown): T {
  if (!body || typeof body !== "object") {
    throw new Error("Invalid item response");
  }
  const root = body as Record<string, unknown>;
  if ("data" in root && root.data !== undefined && !Array.isArray(root.data)) {
    const inner = root.data as Record<string, unknown>;
    if (inner && typeof inner === "object" && "data" in inner && Array.isArray(inner.data)) {
      throw new Error("Expected item response, got paginated envelope");
    }
    return root.data as T;
  }
  return body as T;
}
